import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import Button from '@mui/material/Button';

const ConfirmModal = ({ isOpen, onConfirm, onCancel, heading, children }) => {
  return (
    <Modal
      open={isOpen}
      onClose={onCancel}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 650,
          bgcolor: 'background.paper',
          border: 'none',
          outline: 'none',
          p: 4,
          borderRadius: 5,
        }}
      >
        {heading && (
          <Typography id="modal-modal-title" variant="h6" component="h2">
            {heading}
          </Typography>
        )}

        <>
          <Box sx={{ paddingTop: 2, paddingBottom: 4 }}>
            <Typography variant="p" component="p">
              {children}
            </Typography>
          </Box>

          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Button onClick={onCancel}>Cancel</Button>

            <Button variant="contained" onClick={onConfirm}>
              Confirm
            </Button>
          </Box>
        </>
      </Box>
    </Modal>
  );
};

export default ConfirmModal;
